import { render } from "./subsidiariesSection.vue?vue&type=template&id=20e12640&scoped=true"
import script from "./subsidiariesSection.vue?vue&type=script&lang=js"
export * from "./subsidiariesSection.vue?vue&type=script&lang=js"

import "./subsidiariesSection.vue?vue&type=style&index=0&id=20e12640&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e12640"]])

export default __exports__